// packages/eden-utilities/src/utils/deepMapChildren.js
import { Children } from "react";
var deepMapChildren = (children, callback) => {
  Children.map(
    children,
    (child) => child?.props?.children ? [callback(child), deepMapChildren(child.props.children, callback)] : callback(child)
  );
};
var deepMapChildren_default = deepMapChildren;
export {
  deepMapChildren_default as default
};
